<script setup lang="ts">
type EngravingProps = {
  productStoreLocation: ProductStoreLocation
  loading?: boolean
}
const props = defineProps<EngravingProps>()
const emit = defineEmits<{ submit: [] }>()
const productStore = useProductStore(props.productStoreLocation)
const showSlideIn = ref(false)
const labelId = useId()
const triggerId = useId()

const isShow = computed(
  () => !!productStore.selectedProduct?.c_engravable && !productStore.selectedProduct?.c_sourcedExternally,
)

const onSubmit = (engravingText: string) => {
  productStore.setEngravingText(engravingText)
  showSlideIn.value = false
  emit('submit')
}
</script>

<template>
  <section v-if="isShow" class="engraving" data-testid="engraving">
    <span :id="labelId" class="engraving__label">{{ $t('product.engraving.field_label') }}:</span>
    <Button
      :id="triggerId"
      variant="selector"
      data-testid="engraving__trigger"
      :aria-labelledby="`${labelId} ${triggerId}`"
      :disabled="loading"
      @click="showSlideIn = true"
    >
      {{ productStore.engravingText?.trim() || $t('product.engraving.field_placeholder') }}
    </Button>
    <EngravingSlideIn
      :show="showSlideIn"
      :engraving-text="productStore.engravingText"
      :max-length="productStore.selectedProduct?.c_engravabletextmax"
      :loading="loading"
      @close="showSlideIn = false"
      @submit="onSubmit"
    />
  </section>
</template>

<style lang="postcss">
.engraving {
  display: flex;
  flex-direction: column;
  gap: var(--space-30);

  .engraving__label {
    font-size: var(--text-small);
    text-transform: uppercase;
    line-height: 1.25;
  }
}
</style>
